import { Axios } from "../../utils/axiosMiddleware";
import { SimpleCatchError } from "../../utils/Helper";

/**
 * The enabled plan catalog, in display order.
 *
 * Public by design: the endpoint is @NoAuth server-side so a logged-out visitor
 * sees real prices on the marketing page. It must stay on the shared `Axios`
 * instance without an auth requirement — a 401 here would trip the response
 * interceptor and clear the session of someone who was only reading the page.
 *
 * Each plan: { id, name, description, amount, currency, interval, intervalCount,
 * trialMonth, featureKeys, badgeText, highlighted, displayOrder }.
 */
export const getSubscriptionPlans = async () => {
  try {
    const response = await Axios.get(`/subscription-plans`);
    return Array.isArray(response?.data) ? response.data : [];
  } catch (e) {
    // Deliberately silent. This runs on the public home page for signed-out
    // visitors, and SimpleCatchError renders `${e.response.data.message}` — which
    // stringifies to the literal "undefined" for a 502 HTML page or a 404. The
    // caller renders an empty state; a global error toast on a marketing page is
    // worse than no prices.
    return [];
  }
};

/**
 * The default plan in the legacy shape, for callers that only need one value.
 * Kept so the Home trial-length read is unchanged.
 * `trialMonth` is the admin-set free-trial length in months (nullable / may be 0).
 */
export const getSubscriptionPlan = async () => {
  try {
    const response = await Axios.get(`/subscriptions`);
    return response?.data;
  } catch (e) {
    SimpleCatchError(e);
    return null;
  }
};
